
export class Empresa 
{
 //empresa
    EmpresaId: number;
    Nombre: string;
    NombreLegal: string;
    Abreviacion: string;
    NIF: string;
    Direccion: string;
    CP: string;
    Poblacion: string;
    Provincia: string;
    Telefono1 : string;
    Fax: string;
    EmailEnvio: string;
    CopiaEnvio: string;
    EmailParte: string;
//datos adictionlies
    Tipo: string;
    Sector: string;
    Mutua: string;
    cnae: string;
    ContingenciasComunes: string;
    ImportePorObjetivo: string;
//Datos de control
    CalendarioLaboral: string
    InicioGestion: string; //date
    FinGestion: string;    //date
    PrimerContacto: string;
    MedicoId: string;
    CitacionFormal: string;
    CitacionSMS: string;
    CitacionSMSCert: string;
    IdiomaSms: string;
    CitPlantilla: string;
    CartaPD: string;
    ConvenioId: number;
    salarioBruto: number;
    ContingenciasProfesionales: number;
    CalcularAbsentismo: string;
    CuadroMando: string;
    Duplicidad: string;
    Movilidad: number;
    Revisar: string;
    TieneTrabajadores: string;
    Facturacion: string;
    VisitaEmpresa: number;   
//datos datos heredados
    ParentControl: string;
    Administrativa: string
    Coordinador: string
    TiposBaja: string
    TiposSinGestion: string            
    TipoDiagnostico: string
    BajaNueva: string
    TarifaIndisposicion: string
    Fantiguedad: string
    DiasImpedirTareas: string
    FFinContrato: string;
    ReferenciaBaja: string;
    RefTrabajador: string;
    TipoBorrado: string;            
    ControlAcumulaciones: string;
    ComentarioParaEmpresa: string;
    ImprimirNombreLegalEnTareas: string;
    ObligarCitacionTelefonica: string;
    PAMEM: string;
    PES: string;
    ReclamarSolicitud: string;
    SabadoLaborable: string;
    SeguimientoPostCitacion: string;
    SinDatosMedicos: string;
    TieneSME: string;  
//ficha
    GestionIT:string;
    VisitasDomiciliarias:string;
    Asistencial:string;   
    NoPasanTodasBajas:string;
    ComunicaPostBaja:string;
    AbsentismoBajo:string;
    DispersionGeografica:string;   
    ActividadFueraContrato:string;
    ObsActividad:string;   
    ActividadPresencialNormal:string;//one group
    ActividadPresencialBaja:string;  //one group
    CasosPuntuales:string;           //one group
//contrato
    ContratoRealizado:string;
    ContratoFirmado: string;    
    FinicioContrato: string;   
    DuracionContrato: string;
    FinicioFra: string;
    ProrrogaContrato: string;
    FContratoEnviado: string;   
    FContratoRecibido: string;
    Comercial: string;
 //Facturación
    FENombre: string; 
    FEPersonaContacto: string;  
    FETelefono: string;
    FEDireccion: string;
    FEPoblacion: string;
    FECP: string;   
    FEVariable: string;
    FEFijo: string;   
    FEImporte: number;
    FEPeriodicidad: string;
    FEFechaPago: number;
    FEDiaPago: number;   
    FECodContable: string;
    FECodAnalitico: string;
    FEDestinatario: string;
    FECcentidad : string;
    FECcsucursal : string;   
    FECCDC : string;
    FEcccuenta : string;  
    CriteriosFacturacion: string;
//envio
    ListadoPersonal: string;
    ListadoSme: string;
    ListadoJefe: string;     
    TipoListadoPersonal: string;
    TipoListadoJefe: string;
    TipoListadoSme: string;
    TipoFormatoPersonal: string;
    TipoFormatoSme: string;
    TipoFormatoJefe: string;
    DirPersonal: string;
    DirSME: string;
    DirJefe: string;
    PasswordPersonal: string;
    PasswordSme: string;
    PasswordJefe: string;
    SolicitarAltas: string;
    SolicitarDirecciones: string;
    SolicitudPlantillas: string;
    EmailAltas: string;
    PasswordAlta: string;
    EmailPlantillas: string;
//Observaciones
    Observaciones: string

  }




